export type Fields = {
  label: string;
  value: number;
};

export const getRenderFields = (key: string, data: any): Fields[] => {
  switch (key) {
    case 'funds':
      return [
        { label: 'Resgate', value: data.totalRedemption },
        { label: 'Aplicação', value: data.totalApplication },
      ];
    case 'fixedIncome':
      return [
        { label: 'Resgate', value: data.totalRedemption },
        { label: 'Aplicação', value: data.totalApplication },
      ];
    case 'variableIncome':
      return [
        { label: 'Venda', value: data.totalSale },
        { label: 'Compra', value: data.totalPurchase },
      ];
    case 'treasury':
      return [
        { label: 'Resgate', value: data.totalRedemption },
        { label: 'Aplicação', value: data.totalApplication },
      ];
    case 'publicOffer':
      return [
        { label: 'Reservado', value: data.totalReserved },
        { label: 'Liquidado', value: data.totalSettled },
      ];
    case 'currentAccount':
      return [
        { label: 'Saque', value: data.totalWithdrawal },
        { label: 'Aporte', value: data.totalDeposit },
      ];
    case 'requiredMargin':
      return [
        { label: 'Requerido', value: data.totalRequired },
        { label: 'Em garantia', value: data.totalGuarantee },
      ];
    default:
      return [];
  }
};
